/* eslint-disable */

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import router from './router';
import { store, api } from './store';
import messages from './i18n'
import jwt_decode from 'jwt-decode';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { keycloak, initOptions } from '@/globals/helpers/keycloak-init';
import Permissions from '@/globals/helpers/permissions';
Vue.use(VueSweetalert2);
import VueDragScroll from 'vue-dragscroll';
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production' || true;

// import Vuex ORM models
import Task from './modules/task/store/model';
import Category from './modules/category/store/model';
import Event from './modules/event/store/model';
import Member from './modules/member/store/model';
import MemberDeviation from './modules/member-deviation/store/model'
import Alert from './modules/alerts/store/model';
import Device from './modules/device/store/model';
Vue.prototype.$Task = Task;
Vue.prototype.$Category = Category;
Vue.prototype.$Event = Event;
Vue.prototype.$Member = Member;
Vue.prototype.$MemberDeviation = MemberDeviation;
Vue.prototype.$Alert = Alert;
Vue.prototype.$Device = Device;

// import vuetify components
import vuetify from './plugins/vuetify';

// VueDragScroll
Vue.use(VueDragScroll);

// Translations (VueI18n)
const currentLanguage = navigator.languages[0].split('-')[0];
export { currentLanguage };
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: currentLanguage,
  fallbackLocale: 'en',
  messages,
});

keycloak.init({ onLoad: initOptions.onLoad, checkLoginIframe: false }).then(async (auth) => {

  // set user info in vuex store on authentication
  await keycloak.loadUserInfo().then(async (response) => {
    const roles = await api.get(`roles`);
    store.commit(
      'authentication/setUserFromKeycloak',
      { ...response,
        groups: Object.keys(roles.data).map((key) => {
          return {
            name: key,
            roles: roles.data[key],
          }
        })
      })
  });

  if(!auth) {
    window.location.reload();
  } else {
    console.log("Authenticated");
  }

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
  // make keycloak available on vue instance
  Vue.prototype.$keycloak = keycloak;
  Vue.prototype.$p = Permissions;
  localStorage.setItem("vue-refresh-token", keycloak.refreshToken);

  setInterval(() => {
    keycloak.updateToken(70).then((refreshed)=>{
      if (refreshed) {
        console.log('Token refreshed'+ refreshed);
        console.log('keycloak.token: ', keycloak.token);
      } else {
        console.log('Token not refreshed, valid for '
          + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
      }
    }).catch(()=>{
      console.log('Failed to refresh token');
    });
  }, 60000)

}).catch((error) =>{
  console.log("Authenticated Failed", error);
});
